
shadow.loader.set_loaded();
iris.core.init();